<template>
  <div
    class="page-wrapper"
    style="padding-top: 20px"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div class="content-container">
      <!-- 产品 -->
      <div class="public-view">
        <div
          class="public-item"
          v-for="item in dataSource"
          :key="item.id"
          :style="prodId == item.id ? 'border: 2.5px solid #488eff;' : ''"
          @click="onProdClick(item)"
        >
          <img :src="imageUrl + item.wapImg" alt="" class="zoom-image" />
          <div class="tab-title">{{ item.name }}</div>
        </div>
      </div>
      <!-- 种类 -->
      <div class="category-view">
        <div class="public-view" v-if="productList.length > 0">
          <div
            class="public-item"
            v-for="item in productList"
            :key="item.id"
            :style="
              productId == item.id
                ? 'border:  2.5px solid #488eff; flex-direction: column;height: 90px'
                : ' flex-direction: column;height: 90px'
            "
            @click="productClick(item)"
          >
            <img
              :src="imageUrl + item.pcImg"
              alt=""
              style="width: auto; max-width: 100%; max-height: 100%"
            />
            <div
              class="tab-title text-one-line"
              style="margin-top: 10px; margin-left: 0px"
            >
              {{ item.name }}
            </div>
            <div class="isMaintain" v-if="item.isMaintain">维护</div>
          </div>
        </div>
        <div
          style="background-color: #ccc; height: 1px; margin-top: 10px"
          v-if="faceValueList.length > 0"
        ></div>
        <div class="public-view" v-if="faceValueList.length > 0">
          <div
            class="public-item"
            style="height: 100px; position: relative"
            v-for="item in faceValueList"
            :key="item.fvId"
            :style="
              faceValueId == item.fvId ? 'border:  2.5px solid #488eff;' : ''
            "
            @click="onFaceValueClick(item)"
          >
            <div class="tab-title" style="margin-bottom: 20px">
              {{
                item.rateModel == "customfacevalue"
                  ? item.faceValue
                  : "￥" + item.faceValue
              }}
            </div>
            <div class="public-item-bottom">
              <div class="dis-tag">最新</div>
              <div
                v-if="item.rateModel != 'customfacevalue'"
                style="flex-shrink: 0"
              >
                {{ item.showRate }}折｜¥{{ item.showAmount }}
              </div>
              <div v-else>
                {{
                  item.faceValue == "自定义"
                    ? item.showRate + "折"
                    : item.showRate + "折|" + "¥" + item.showAmount + ""
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 行情 -->
      <div class="market-view" v-show="marke">
        <div class="market-title">
          <div class="market-title-line"></div>
          <div>行情信息</div>
        </div>
        <!-- 供需行情 -->
        <div class="market-content">
          <div class="market-item">
            <div class="item-header">
              <div class="item-left">
                <img src="@/assets/image/下载 (1).png" alt="" />
                <div class="item-title">供需行情</div>
                <img src="@/assets/image/下载 (4).png" alt="" />
              </div>
            </div>
            <div class="market-item-content">
              <div class="market-item-view">
                <div
                  class="market-label-view"
                  style="border-left: 2px solid red"
                >
                  <div>卖方</div>
                  <div>折扣 | 价格</div>
                  <div>供给数量(张)</div>
                </div>
              </div>
              <div class="market-item-view" style="flex: 1; overflow-y: scroll">
                <div
                  class="market-item-cell"
                  v-for="(item, index) in buyList"
                  :key="item.id"
                  :style="index % 2 !== 0 ? 'background-color: #FF421514;' : ''"
                >
                  <div style="flex: 1; text-align: center; color: #ff4215">
                    {{ item.name }}
                  </div>
                  <div style="flex: 1; text-align: center; color: #ff4215">
                    {{ item.discount }}
                  </div>
                  <div style="flex: 1; text-align: center">{{ item.num }}</div>
                </div>
                <div style="background-color: red; height: 2px"></div>
                <div
                  class="market-item-cell"
                  v-for="(item, index) in sellList"
                  :key="item.id"
                  :style="index % 2 !== 0 ? 'background-color: #48cc9914;' : ''"
                >
                  <div style="flex: 1; text-align: center; color: #48cc99">
                    {{ item.name }}
                  </div>
                  <div style="flex: 1; text-align: center; color: #48cc99">
                    {{ item.discount }}
                  </div>
                  <div style="flex: 1; text-align: center">{{ item.num }}</div>
                </div>
              </div>
              <div class="market-item-view">
                <div
                  class="market-label-view"
                  style="border-left: 2px solid #48cc99; margin-bottom: 40px"
                >
                  <div>卖方</div>
                  <div>折扣 | 价格</div>
                  <div>需求数量(张)</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 最近24小时成交明细 -->
          <div class="market-item" style="margin: 0px 30px">
            <div class="item-header">
              <div class="item-left">
                <img src="@/assets/image/下载 (2).png" alt="" />
                <div class="item-title">最近24小时成交明细</div>
                <img src="@/assets/image/下载 (4).png" alt="" />
              </div>
            </div>
            <div class="market-item-content">
              <div class="market-item-view">
                <div
                  class="market-label-view"
                  style="background-color: rgb(234, 244, 255)"
                >
                  <div>成交时间</div>
                  <div>折扣(%)</div>
                  <div>成交数量(张)</div>
                </div>
              </div>
              <div
                class="market-item-view"
                style="
                  flex: 1;
                  overflow-y: scroll;
                  scrollbar-width: none; /* Firefox */
                  -ms-overflow-style: none;
                "
              >
                <div
                  class="market-item-cell"
                  v-for="(item, index) in dealTimeList"
                  :key="item.id"
                  :style="index % 2 !== 0 ? 'background-color: #f5f6f9;' : ''"
                >
                  <div style="flex: 1; text-align: center">{{ item.name }}</div>
                  <div style="flex: 1; text-align: center">
                    {{ item.discount }}
                  </div>
                  <div style="flex: 1; text-align: center">{{ item.num }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="market-item">
            <div class="item-header">
              <div class="item-left">
                <img src="@/assets/image/下载 (3).png" alt="" />
                <div class="item-title">成交折扣走势</div>
                <img src="@/assets/image/下载 (4).png" alt="" />
              </div>
              <div class="item-right">
                <div class="item-btn">
                  <div
                    class="btn-view"
                    :style="
                      timeType === 0
                        ? 'background-color: #488eff; color: white;'
                        : ''
                    "
                    @click="onTimeClick(0)"
                  >
                    24小时走势
                  </div>
                  <div
                    class="btn-view"
                    :style="
                      timeType !== 0
                        ? 'background-color: #488eff; color: white;'
                        : ''
                    "
                    @click="onTimeClick(1)"
                  >
                    30天走势
                  </div>
                </div>
                <div class="time-labe">02-12 15:45 ~ 02-13 15:40</div>
              </div>
            </div>
            <div class="discount-view" style="flex-shrink: 0">
              供货折扣区间：92.00%~102.00%
            </div>
            <div class="chart-view" ref="chart"></div>
            <div class="market-bottom">
              {{ timeType === 0 ? "时间/最近24h" : "时间/最近30天" }}
            </div>
          </div>
        </div>
      </div>
      <!-- 验卡 -->
      <div class="verification-view">
        <div class="verification-top-bg">
          <img src="@/assets/image/limit-bg.CvRzEXUo.png" />
          <div class="verification-top-content">今天可用额度：¥{{this.isLoggedIn?this.userData.sellCardQuota:0 }}</div>
        </div>
        <!-- raterang -->
        <div class="discount-input-view" v-if="rateModel == 'raterang'">
          <div class="verification-title" style="flex-shrink: 0">
            供货折扣：
          </div>
          <div style="width: 360px; position: relative">
            <el-input
              placeholder="请输入内容"
              v-model="form.faceValue"
            ></el-input>
            <span class="percentage">%</span>
          </div>
          <div style="font-size: 14px; font-weight: 500; margin-left: 20px">
            可以输入的折扣：{{ minRate }}%-{{
              maxRate
            }}%，折扣越高核销越慢，按默认折扣提交核销更快
          </div>
        </div>
        <div class="way-view">
          <div class="verification-title" style="flex-shrink: 0">
            提交方式：
          </div>
          <div
            class="consult-btn"
            :style="
              way === 0
                ? 'border: 1px solid #488eff; color: #488eff;'
                : 'border: 1px solid #000000a6; color: #000000a6;'
            "
            @click="onWayClick(0)"
          >
            批量提交
          </div>
          <div
            class="consult-btn"
            :style="
              way !== 0
                ? 'border: 1px solid #488eff; color: #488eff; margin-left: 25px;'
                : 'border: 1px solid #e0e0e0; color: #000000a6; margin-left: 25px;'
            "
            @click="onWayClick(1)"
          >
            单卡提交
          </div>
        </div>
        <!-- 输入卡号 -->
        <div class="import-card">
          <div class="verification-title" style="flex-shrink: 0">
            {{productData.carmine!=2 && productData.carmine!=3?" 卡号/卡密：":'卡密'}}
          </div>
          <div class="import-one" v-show="way === 0">
            <div class="import-one-bg">
              <div
                class="import-one-bg-item"
                :style="index % 2 === 0 ? 'background-color: #F5F6FC;' : ''"
                v-for="(item, index) in 7"
                :key="item"
              ></div>
            </div>
            <div v-if="!isLoggedIn" class="not-logged-wrapper">
              <div class="not-logged-content">
                <img
                  src="@/assets/newImage/fail-img.DgrGML6a.png"
                  alt="warning"
                  class="warning-icon"
                />
                <div class="warning-text">登录账号后才能进行销卡</div>
                <el-button
                  type="primary"
                  style="margin-top: 20px"
                  @click="handleLogin"
                  >立即登录</el-button
                >
              </div>
            </div>
            <div class="import-one-content" v-else>
              <textarea
                class="textarea-view cus-scroll-bar"
                v-model="inputValue"
                @input="onHandleInput"
              ></textarea>
            </div>
          </div>
          <div class="import-one-hint" v-show="way === 0">
            <div class="import-one-hint-content">
              <img src="@/assets/image/download.png" />
              <div style="color: red">{{ productData.tip }}</div>
            </div>
          </div>
          <div style="display: flex; height: 250px">
            <div class="import-tow" v-show="way !== 0">
              <el-input
                v-model="cardNumber"
                :placeholder="productData.carmine!=2 && productData.carmine!=3?'输入卡号':'输入卡密'"
                style="width: 430px"
              ></el-input>
              <el-input
                v-if="productData.carmine!=2 && productData.carmine!=3"
                v-model="cardKey"
                placeholder="输入卡密"
                style="width: 430px; margin-top: 10px"
              ></el-input>
            </div>
            <div
              class="import-one-hint"
              v-show="way != 0"
              style="margin-left: 100px"
            >
              <div class="import-one-hint-content">
                <img src="@/assets/image/download.png" />
                <div style="color: red">{{ productData.tip }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-view">
          <div class="bottom-item" v-if="way === 0">
            <div class="arrn-btn">整理卡号卡密</div>
            <div class="sub-txt">
              已经输入
              <span class="txt-blue">{{ carNum }}</span> 张面值¥{{
                faceData.faceValue
              }}元的卡，每次最多可提交 2000 张
            </div>
          </div>
          <div class="bottom-item" style="margin-top: 10px">
            <div>
              <el-checkbox v-model="checked1">
                <span class="sub-txt">我已阅读，理解并同意</span>
              </el-checkbox>
            </div>
            <div class="txt-link" @click="goToUser(4.4)">《转让协议》</div>
          </div>
          <div
            class="bottom-item"
            style="margin-top: 10px; padding-bottom: 10px"
          >
            <div>
              <el-checkbox v-model="checked2">
                <span class="sub-txt"
                  >本站只提供来路合法的购物卡或礼品卡寄售，严禁提交来源非法卡券，用户对自己的寄售行为承担法律责任。</span
                >
              </el-checkbox>
            </div>
          </div>
          <el-button type="primary" @click="submitOrder" :disabled="!isLoggedIn"
            >确定提交</el-button
          >
        </div>
      </div>
    </div>
    <floatingSidebar></floatingSidebar>
    <!-- 提交订单 -->
    <el-dialog
      title="提交确认"
      :visible.sync="dialogVisible"
      class="custom-dialog"
      width="550px"
    >
      <div class="warning-message">
        <i class="el-icon-warning"></i>
        切记面值选择错误，则可能全单损失，提交失效卡密，账号和资金会被永久冻结！若卡密总面值超过当日限额，超出的可能会被自动忽略
      </div>
      <div class="form-item" style="margin-top: 20px">
        <label>提交卡种</label>
        <span class="form-value">{{ productData.name }}</span>
      </div>
      <div class="form-item">
        <label>选择面值</label>
        <span class="form-value">{{ faceData.faceValue }}元</span>
      </div>
      <div class="form-item">
        <label>提交卡密</label>
        <span class="form-value">{{ way == 0 ? carNum : 1 }}张</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定提交</el-button>
      </div>
    </el-dialog>
    <!--  自定义面值 -->
    <el-dialog
      title="自定义面值"
      :visible.sync="customDialogVisible"
      width="20%"
      :before-close="handleClose"
    >
      <el-input
        v-model="customfacevalue"
        :placeholder="customfacevaluePlaceholder"
        @input="handleCustomFaceValue"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="customDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import http from "@/utils/http/axios";
import Cokie from "js-cookie"; //
import floatingSidebar from "../components/base/floating-sidebar.vue";
export default {
  components: {
    floatingSidebar,
  },
  data() {
    return {
      // 自定义面值
      customDialogVisible: false, //
      customfacevalue: "0", // 自定义面值
      customfacevaluePlaceholder: "", // 自定义面值placeholder
      rateConfig: null,
      rate: "",
      rateModel: "",
      // 自定义费率
      minRate: 0,
      maxRate: 0,
      userData:undefined,

      isLoggedIn: !Cokie.get("token") ? false : true,
      cardNumberLength: 0,
      cardKeyLength: 0,
      dialogVisible: false,
      checked2: false,
      checked1: false,
      form: {
        cardType: "",
        faceValue: "",
        cardCode: "",
        repeatCardCode: "",
        actualSubmit: "",
      },
      fullscreenLoading: false, //加载动画
      marke: false, //隐藏行情
      // imageUrl: "https://admin.huishouka.com.cn",
      imageUrl:'',
      dataSource: [], // 商品分类列表
      productList: [], // 商品列表
      faceValueList: [], // 面值列表
      prodId: "", // 商品分类列表ID
      productId: "", // 商品列表ID
      faceValueId: "",
      timeType: 0,
      inputValue: "",
      carNum: 0,
      way: 0,
      inputNum: 0, // 输入框触发次数
      inputTag: 1, // 输入类型账号还是密码
      input2: "",
      radio: 0,
      input: "",
      // 卡号
      cardNumber: "",
      //卡密
      cardKey: "",
      buyList: [
        { name: "买方1", discount: "95%", num: "10", tag: 0 },
        { name: "买方2", discount: "93%", num: "21", tag: 0 },
        { name: "买方3", discount: "92.6%", num: "3", tag: 0 },
        { name: "买方4", discount: "94%", num: "6", tag: 0 },
        { name: "买方5", discount: "95%", num: "10", tag: 0 },
        { name: "买方6", discount: "93%", num: "21", tag: 0 },
      ],
      sellList: [
        { name: "卖方1", discount: "92%", num: "10", tag: 1 },
        { name: "卖方2", discount: "97%", num: "11", tag: 1 },
        { name: "卖方3", discount: "91%", num: "50", tag: 1 },
        { name: "卖方4", discount: "88%", num: "7", tag: 1 },
      ],
      dealTimeList: [
        { name: "01-11", discount: "92%", num: "10", tag: 1 },
        { name: "01-14", discount: "97%", num: "11", tag: 1 },
        { name: "01-20", discount: "91%", num: "50", tag: 1 },
        { name: "01-22", discount: "88%", num: "7", tag: 1 },
        { name: "01-11", discount: "92%", num: "10", tag: 1 },
        { name: "01-14", discount: "97%", num: "11", tag: 1 },
        { name: "01-20", discount: "91%", num: "50", tag: 1 },
        { name: "01-22", discount: "88%", num: "7", tag: 1 },
        { name: "01-11", discount: "92%", num: "10", tag: 1 },
        { name: "01-14", discount: "97%", num: "11", tag: 1 },
        { name: "01-20", discount: "91%", num: "50", tag: 1 },
        { name: "01-22", discount: "88%", num: "7", tag: 1 },
        { name: "01-11", discount: "92%", num: "10", tag: 1 },
        { name: "01-14", discount: "97%", num: "11", tag: 1 },
        { name: "01-20", discount: "91%", num: "50", tag: 1 },
        { name: "01-22", discount: "88%", num: "7", tag: 1 },
        { name: "01-11", discount: "92%", num: "10", tag: 1 },
        { name: "01-14", discount: "97%", num: "11", tag: 1 },
        { name: "01-20", discount: "91%", num: "50", tag: 1 },
        { name: "01-22", discount: "88%", num: "7", tag: 1 },
        { name: "01-11", discount: "92%", num: "10", tag: 1 },
        { name: "01-14", discount: "97%", num: "11", tag: 1 },
        { name: "01-20", discount: "91%", num: "50", tag: 1 },
        { name: "01-22", discount: "88%", num: "7", tag: 1 },
      ],
      productData: {},
      faceData: {},
    };
  },
  mounted() {
    if (this.$store.state.prodIdX) {
      this.prodId = this.$store.state.prodIdX;
    }
    if (this.$store.state.productIdX) {
      this.productId = this.$store.state.productIdX;
    }
    this.getTypeList();
    if(this.isLoggedIn){
      this.getUserInfo();
    }
 
    window.scrollTo(0, 0); // 滚动到顶部
  },

  created() {
    this.$bus.$on("changedProdId", this.changeProdId);
  },

  methods: {
    // 获取用户信息
    getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.userData = response.data;
            console.log(this.userData);
            
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },

    goToUser(vl) {
      this.$store.commit("changedMenuId", 4);
      this.$store.commit("changedLeftChildId", vl);
      window.scrollTo(0, 0);
      this.$router.push({ path: "/HelpCentre" });
    },
    // 修改prodId
    changeProdId(newValue) {
      this.prodId = newValue;
      this.getProductList(this.prodId);
    },

    // 商品分类点击事件
    onProdClick(vl) {
      this.inputValue = "";
      this.carNum = 0;
      this.prodId = vl.id;
      this.productId = "";
      this.getProductList(this.prodId);
      this.productList = [];
      this.faceValueList = [];
      this.form.faceValue = "";
      this.cardNumber = "";
      this.cardKey = "";
    },
    // 商品列表点击事件
    productClick(vl) {
      console.log(vl);
      if (vl.isMaintain) {
        this.$message.error("当前卡券维护中暂停核销,努力恢复中...");
        return;
      }
      this.inputValue = "";
      this.carNum = 0;
      this.handleProductData(vl);
      this.getFaceValueList(this.productId);
      this.form.faceValue = "";
      this.cardNumber = "";
      this.cardKey = "";
    },
    //处理product数据
    handleProductData(vl) {
      this.productData = vl;
      this.productId = vl.id;
      this.cardNumberLength = this.productData.cardDigit;
      this.cardKeyLength = this.productData.secretDigit;
      console.log(this.cardNumberLength,this.cardKeyLength);
      
    },
    // 面值列表点击事件
    onFaceValueClick(vl) {
      this.inputValue = "";
      this.carNum = 0;
      this.faceValueId = vl.fvId;
      this.form.faceValue = "";
      this.handleFaceValue(vl);
      this.cardNumber = "";
      this.cardKey = "";
    },
    //商品分类列表
    getTypeList() {
      this.fullscreenLoading = true;
      setTimeout(() => {
        this.fullscreenLoading = false;
      }, 500);
      this.dataSource = [];
      http
        .get("/product/type/list")
        .then((response) => {
          if (response.code == 200) {
            for (let index = 0; index < response.data.length; index++) {
              const element = response.data[index];
              if (element.type == 1) {
                this.dataSource.push(element);
              }
            }
            if (this.dataSource.length > 0) {
              if (!this.prodId) {
                this.prodId = this.dataSource[0].id;
              }

              this.getProductList(this.prodId);
            }
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    //商品列表
    getProductList(vl) {
      http
        .get("/product/product/list?prodTypeId=" + vl)
        .then((response) => {
          if (response.code == 200) {
            this.productList = response.data;
            if (this.productList.length > 0) {
              if (!this.productId) {
                this.handleProductData(this.productList[0]);
              } else {
                for (let index = 0; index < response.data.length; index++) {
                  const element = response.data[index];
                  if (element.id == this.productId) {
                    this.productData = element;
                    break;
                  }
                }
              }
              this.getFaceValueList(this.productId);
            }
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },

    //面值列表
    getFaceValueList(vl) {
      http
        .get("/product/faceValue/list?prodId=" + vl)
        .then((response) => {
          if (response.code == 200) {
            this.faceValueList = response.data;
            this.faceValueList.forEach((item) => {
              if (item.rateModel == "customfacevalue") {
                item.faceValue = "自定义";
              }
            });
          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
    // 提交订单
    submit() {
      let cards =  this.inputValue.replace(/\n/g, ',');
      //把 cards 中的空格去掉
      cards = cards.replace(/\s/g, ',');
      //把 cards 中的换行符号去掉
      cards = cards.replace(/\n/g, ',');
      console.log(cards);
      let data = {
        prodId: this.productId,
        fvId: this.faceValueId,
        submitType: this.way == 0 ? 2 : 1,
        cards: this.way == 0 ? cards : this.cardNumber + "," + this.cardKey,
        platform: 3,
      };
      if (this.faceData.rateModel == "raterang") {
        data.faceValue = this.faceData.faceValue;
        data.discount = (this.form.faceValue / 100).toFixed(2);
      }
      if (this.faceData.rateModel == "customfacevalue") {
        data.faceValue = this.faceData.faceValue;
        data.discount = this.faceData.rate;
      }
      
     http.post("/order/submit", data).then((response) => {
        if (response.code == 200) {
          this.$message.success("提交成功");
          this.inputValue = "";
          window.scrollTo(0, 0);
          this.carNum = 0;
          this.cardKey = "";
          this.cardNumber = "";
          this.getUserInfo();
        } else {
          this.$message.error(response.msg);
        }
      });
      this.dialogVisible = false;
    },
    // 提交订单
    submitOrder() {
      if (!this.faceData.faceValue) {
        this.$message.error("请选择对应的面值");
        return;
      }
      const value = Number(this.form.faceValue);
      if (this.rateModel == "raterang") {
        if (value < this.minRate || value > this.maxRate) {
          this.$message.error(
            `折扣必须在 ${this.minRate}% 到 ${this.maxRate}% 之间`
          );
          return;
        }
      }
      if (!this.checked2 || !this.checked1) {
        this.$message.error("请勾选转让协议");
        return;
      }
      if (this.way != 0) {
        if (this.productData.carmine!=2 && this.productData.carmine!=3) {
          if (!this.cardNumber || !this.cardKey) {
          this.$message.error("请输入卡号和卡密");
          return;
        }
        }else{
          if (!this.cardNumber ) {
          this.$message.error("请输入卡号和卡密");
          return;
        }

        }
       
      } else {
        if (!this.inputValue) {
          this.$message.error("请输入卡号");
          return;
        }
        let cards = this.inputValue.replace(/ /g, ",");
        let arr = cards.split("\n");
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (!this.createDynamicRegex(element)) {
            this.$message.error("请输入正确的卡号和卡密");
            return;
          }
        }
      }
      this.dialogVisible = true;
    },
    // 前往登录

    handleLogin() {
      this.$router.push("/login");
    },

    // /order/submit
    // 切换方式
    onWayClick(vl) {
      if (!this.isLoggedIn) {
        return;
      }
      this.way = vl;
    },
    onHandleInput(event) {
      const newStr = event.target.value.split("-").join("");

      if (this.cardNumberLength + this.cardKeyLength == 0) {
        this.inputValue = newStr;
        return;
      }

      const value = newStr;
      // 按行分割输入内容
      const lines = value.split("\n");
      const formattedLines = [];
      
      // 处理自动添加空格和换行
      if (event.inputType === 'insertText' && event.data !== null) {
        const lastLine = lines[lines.length - 1].replace(/\s/g, "");
        
        // 如果最后一行的长度正好等于cardNumberLength，自动添加空格
        if (lastLine.length === this.cardNumberLength) {
          this.inputValue = value + ' ';
          event.target.value = this.inputValue;
          return;
        }
        
        // 检查最后一行是否包含完整卡号和部分卡密
        if (lastLine.length > this.cardNumberLength) {
          // 计算卡密已输入的长度
          const cardKeyInputLength = lastLine.length - this.cardNumberLength;
          
          // 如果卡密长度正好等于预期长度，自动添加换行符
          if (cardKeyInputLength === this.cardKeyLength) {
            this.inputValue = value + '\n';
            // 设置值并提前返回，避免重复处理
            event.target.value = this.inputValue;
            return;
          }
        }
      }
      
      lines.forEach((line) => {
        // 清理现有空格
        const cleanLine = line.replace(/\s/g, "");
        //计算卡号和卡密总长度
        const totalLength = this.cardNumberLength + this.cardKeyLength;

        // 按规则分组处理
        let processed = "";
        //开启循环，每次递增总长度
        for (let i = 0; i < cleanLine.length; i += totalLength) {
          //提取总长度字符串为一组
          const group = cleanLine.slice(i, i + totalLength);
          //从组里提取卡号
          const cardNumber = group.slice(0, this.cardNumberLength);
          //从组里提取卡密
          const cardKey = group.slice(this.cardNumberLength, totalLength);

          // 构建格式化字符串，先添加卡号
          let formatted = cardNumber;
          //卡密不为空添加卡密
          if (cardKey) formatted += ` ${cardKey}`;
          //最后添加换行符
          processed += formatted + "\n";
        }
        //将格式化后的添加到数组
        formattedLines.push(processed.trim());
      });

      // 更新输入框内容（保留光标位置），将数组所有行用换行符连接，并去掉首位空白
      this.inputValue = formattedLines.join("\n").trim();
      this.inputValue.replace(/-/g, "");

      let cards = this.inputValue.replace(/ /g, ",");
      const arr = cards.split("\n");
      this.carNum = arr.length;
    },

    insertCommaAt(str, index) {
      return str.slice(0, index) + "  " + str.slice(index);
    },
    // 切换时间
    onTimeClick(vl) {
      this.timeType = vl;
    },
    // 初始化图表
    initChart() {
      const myChart = echarts.init(this.$refs.chart);
      const option = {
        title: {
          text: "成交折扣（%）",
          textStyle: {
            color: "#999",
            fontSize: 12,
          },
        },
        tooltip: {},
        legend: {
          data: ["销量"],
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {},
        series: [
          {
            type: "line",
            areaStyle: {},
            data: [5, 20, 36, 10, 10, 20],
          },
        ],
      };
      myChart.setOption(option);
    },
    createDynamicRegex(patternStr) {
      if (patternStr.startsWith("/")) {
        const parts = patternStr.split("/");

        const flags = parts.pop();

        const pattern = parts.slice(1).join("/");

        return new RegExp(pattern, flags);
      } else {
        return new RegExp(patternStr);
      }
    },
    //处理面值
    handleFaceValue(vl) {
      this.faceData = vl;
      this.rateModel = vl.rateModel;
      this.handleCustomRate(vl);
      if (vl.rateModel == "customfacevalue") {
        if (vl.showAmount == null) {
          this.rate = vl.rate;
        } else {
          vl.rate = this.rate;
        }
        try {
          // 将字符串转换为数组对象
          const rateArray = JSON.parse(vl.rate);
          // 找出最大和最小面值
          const maxFaceValue = Math.max(...rateArray.map((item) => item.max));
          const minFaceValue = Math.min(...rateArray.map((item) => item.min));

          // 根据面值获取对应的折扣率
          const getRateByFaceValue = (value) => {
            const rateItem = rateArray.find(
              (item) => value <= item.max && value >= item.min
            );
            return rateItem ? rateItem.rate : null;
          };
          // 最大面值 从而限制输入框输入位数
          this.maxFaceValue = maxFaceValue;
          this.customfacevaluePlaceholder = `请输入${minFaceValue}元-${maxFaceValue}元面值`;

          // 存储解析后的数据供后续使用
          this.rateConfig = {
            maxValue: maxFaceValue,
            minValue: minFaceValue,
            rateArray: rateArray,
            getRateByFaceValue: getRateByFaceValue,
          };

          this.customDialogVisible = true;
        } catch (error) {
          console.error("解析折扣率配置失败:", error);
          this.$message.error("折扣率配置格式错误");
        }
      }
    },
    // 自定义面值确认
    handleCustomFaceValue() {
      const value = Number(this.customfacevalue);
      if (!value) {
        this.$message.error("请输入有效的面值");
        return;
      }
      const { minValue, maxValue, getRateByFaceValue } = this.rateConfig;
      if (value < minValue || value > maxValue) {
        // 禁止输入
        this.customfacevalue = "";
        this.$message.error(`面值必须在 ${minValue} 到 ${maxValue} 之间`);
        return;
      }
      const rate = getRateByFaceValue(value);
      // 根据输入的值，获取对应的折扣率
      if (!rate) {
        this.$message.error("无法获取对应折扣率");
        return;
      }
      // 设置自定义面值和对应折扣率
      this.faceData = {
        ...this.faceData,
        faceValue: value,
        rate: rate,
        showRate: (rate * 100).toFixed(2),
        showAmount: (value * rate).toFixed(2),
      };
      // 修改面值列表
      this.faceValueList.forEach((item) => {
        if (item.fvId == this.faceData.fvId) {
          item.faceValue = value;
          item.rate = rate;
          item.showRate = (rate * 100).toFixed(2);
          item.showAmount = (value * rate).toFixed(2);
        }
      });
    },
    // 处理自定义费率
    handleCustomRate(vl) {
      this.faceData.faceValue = vl.faceValue;
      if (vl.rateModel == "raterang") {
        let rate = vl.rate;
        let rateArray = JSON.parse(rate);
        this.minRate = (rateArray[0] * 100).toFixed(2);
        this.maxRate = (rateArray[1] * 100).toFixed(2);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrapper {
  width: 100%;
  min-width: 1000px;
  // background-color: #f8f8fa;
  background-color: #f4f6fc;

  .content-container {
    min-width: 1000px;
    margin: auto;
    width: 85%;
    box-sizing: border-box;
  }

  .public-view {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    position: relative;
    box-sizing: border-box;
  }

  .category-view {
    margin-top: 20px;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
  }

  .market-view {
    margin-top: 20px;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
  }

  .verification-view {
    margin-top: 20px;
    background-color: white;
    border-radius: 10px;
  }

  .public-item {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    position: relative;

    .isMaintain {
      position: absolute;
      top: 0px;
      right: 0px;
      width: 45px;
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      border-top-right-radius: 10px;
      border-bottom-left-radius: 10px;
      text-align: center;
      background-color: #ff4215;
      color: white;
      font-size: 12px;
      font-weight: 500;
      z-index: 1;
    }

    .public-item-bottom {
      display: flex;
      background: #e4edfa;
      height: 28px;
      align-items: center;
      padding: 0px 10px;
      justify-content: center;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-bottom-right-radius: 10.5px;
      border-bottom-left-radius: 10.5px;
      font-size: 14px;

      .dis-tag {
        background: #fff9e9;
        border-radius: 4px;
        color: #ffbd00;
        display: inline-block;
        font-size: 12px;
        font-weight: 500;
        height: 20px;
        line-height: 20px;
        margin: 4px 8px 0 0;
        width: 28px;
        line-height: 20px;
        text-align: center;
        flex-shrink: 0;
      }
    }

    img {
      width: 40px;
      height: 40px;
    }

    .tab-title {
      margin-left: 10px;
      font-size: 18px;
    }
  }

  .public-item:hover {
    border: 1px solid #488eff;
    font-weight: 600;

    .zoom-image {
      animation: zoom 0.5s ease-in-out;
      animation-fill-mode: forwards;
    }

    .public-item-bottom {
      background: #488eff;
      color: white;

      .dis-tag {
        background: #ffbd00;
        color: white;
      }
    }
  }

  @keyframes zoom {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(0.7);
    }

    100% {
      transform: scale(1);
    }
  }

  .zoom-image {
    transition: transform 0.5s ease-in-out;
    transform-origin: top left;
  }

  .market-title {
    display: flex;
    align-items: center;
    color: #000000e0;
    font-size: 18px;
    font-weight: 600;

    .market-title-line {
      background: #498eff;
      height: 25px;
      width: 4px;
      margin-right: 10px;
    }
  }

  .market-content {
    flex: 1;
    display: flex;
    justify-content: space-evenly;
    padding: 15px 10px;
    margin-top: 10px;

    .market-bottom {
      display: flex;
      justify-content: end;
      font-weight: 500;
      font-size: 12px;
    }

    .market-item {
      height: 475px;
      box-shadow: 0 0 10px 1px #488eff33;
      border-radius: 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 10px;

      .item-title {
        font-size: 18px;
        font-weight: 500;
        color: black;
        margin: 0px 5px;
      }

      .item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item-left {
          display: flex;
          align-items: center;
        }

        .item-right {
          display: flex;
          flex-direction: column;
          align-items: center;

          .item-btn {
            display: flex;
            height: 40px;
            width: 200px;
            margin-top: 20px;
            border-radius: 6px;
            border: 2px solid #488eff;

            .btn-view {
              width: 50%;
              border-radius: 5px;
              font-size: 14px;
              font-weight: 500;
              line-height: 40px;
              text-align: center;
              color: #488eff;
            }
          }

          .time-labe {
            margin-top: 5px;
            color: #999;
            font-size: 14px;
          }
        }
      }

      .discount-view {
        margin: 0px 20px;
        margin-top: 10px;
        height: 36px;
        background-color: #fff4db;
        border-radius: 10px;
        padding: 0px 10px;
        line-height: 36px;
        color: #a95300;
        font-size: 14px;
      }

      .chart-view {
        flex: 1;
        margin-top: 10px;
      }

      .market-item-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .market-item-view {
          .market-label-view {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            height: 36px;
            background-color: #f5f6f9;
          }

          .market-item-cell {
            height: 35px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .verification-top-bg {
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    background: linear-gradient(270deg, #fff2d4, #fff);

    img {
      width: 289px;
      height: 40px;
    }

    .verification-top-content {
      position: absolute;
      top: 0;
      width: 289px;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9b6600;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .verification-title {
    font-size: 16px;
    font-weight: 500;
    margin-right: 40px;
    text-align: left;
  }

  .discount-input-view {
    padding: 0 80px;
    margin-top: 30px;
    display: flex;
    align-items: center;

    .percentage {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }

  .consult-view {
    margin: 0px 80px;
    margin-top: 10px;
    background: #fff4db;
    border-radius: 8px;
    color: #a95300;
    font-size: 12px;
    font-weight: 400;
    height: 40px;
    line-height: 40px;
    padding: 0px 10px;
  }

  .way-view {
    padding: 0 80px;
    margin-top: 30px;
    display: flex;
    align-items: center;

    .consult-btn {
      width: 180px;
      height: 40px;
      border-radius: 5px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }

  .import-card {
    padding: 0 80px;
    margin-top: 30px;
    display: flex;

    .import-one-hint {
      width: 438px;
      background: #dde3f8;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      position: relative;

      .import-one-hint-content {
        position: absolute;
        top: 20px;
        bottom: 20px;
        left: 20px;
        right: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        border-radius: 10px;
        background-color: white;
        padding: 0px 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #535f89;

        img {
          height: 65px;
          margin: 20px auto 17px;
          width: 47px;
        }
      }
    }

    .import-one {
      flex: 1;
      height: 238px;
      position: relative;

      .import-one-bg {
        .import-one-bg-item {
          height: 30px;
        }
      }

      .not-logged-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        background-color: rgba(255, 255, 255, 0.9);

        .not-logged-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }

      .import-one-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 5px;

        .textarea-view {
          width: 100%;
          height: 100%;
          background-color: transparent;
          border: none;
          resize: none;
          color: #000000e0;
          font-size: 14px;
          outline: none;
          line-height: 30px;
          padding: 10px;
        }
      }
    }

    .import-tow {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: -10px;
    }
  }

  .bottom-view {
    padding: 0 80px;
    margin-top: 20px;
    padding-bottom: 40px;

    .bottom-item {
      display: flex;
      align-items: center;

      .arrn-btn {
        color: #488eff;
        cursor: pointer;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 500;
        margin-right: 14px;
        text-decoration: underline;
      }

      .sub-txt {
        color: #00000073;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
      }

      .txt-blue {
        color: #488eff !important;
      }
    }
  }
}

.cus-scroll-bar::-webkit-scrollbar {
  width: 6px !important;
}

.cus-scroll-bar::-webkit-scrollbar-thumb {
  background: #e5e6eb;
  border-radius: 8px;
}

.warning-message {
  padding: 10px;
  background-color: #fffbcc;
  border-radius: 6px;
  color: #c74c00;
  display: flex;
  align-items: center;
}

.warning-message i {
  margin-right: 10px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background-color: #f0f9ff;
  height: 50px;
  padding: 0 10px;
  border-radius: 10px;
}

.form-item label {
  width: 150px;
}

.form-value {
  flex: 1;
  padding: 10px;

  border-radius: 6px;
  text-align: right;
}
</style>
